export default "/build/static/fonts/Whitney-MediumItal_Web.woff";